import React from 'react';
import { FileText, Shield, RotateCcw, Mail } from 'lucide-react';

interface FooterProps {
  onNavigate: (view: string) => void;
}

export const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  const CONTACT_EMAIL = 'vitacore.fit.wellness@gmail.com';

  const footerLinks = [
    { id: 'privacy', label: 'Privacy Policy', icon: <Shield size={16} /> },
    { id: 'terms', label: 'Terms & Conditions', icon: <FileText size={16} /> },
    { id: 'refund', label: 'Refund Policy', icon: <RotateCcw size={16} /> },
    { id: 'contact', label: 'Contact', icon: <Mail size={16} /> },
  ];

  return (
    <footer className="border-t border-slate-900/50 bg-black/40 backdrop-blur-xl mt-auto">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-6">
          {footerLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => onNavigate(link.id)}
              className="flex items-center gap-2 text-slate-400 hover:text-emerald-400 transition-colors text-sm font-bold uppercase tracking-wider group"
            >
              <span className="group-hover:scale-110 transition-transform">{link.icon}</span>
              {link.label}
            </button>
          ))}
        </div>
        
        <div className="pt-6 border-t border-slate-900/50 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-600 text-xs font-bold uppercase tracking-widest">
            © {new Date().getFullYear()} VitaCore. All rights reserved.
          </p>
          <a 
            href={`mailto:${CONTACT_EMAIL}`}
            className="flex items-center gap-2 text-slate-500 hover:text-emerald-400 transition-colors text-xs font-bold uppercase tracking-wider"
          >
            <Mail size={14} />
            {CONTACT_EMAIL}
          </a>
        </div>
      </div>
    </footer>
  );
};

